import { CustomText, ListItemsWithImage } from '@vfit/shared/atoms';
import { purify } from '@vfit/shared/themes';
import { IAddBulletListProps } from './iAddBulletList.models';
import { BulletListContainer, CustomDesc, CustomTitle } from './iAddBulletList.style';

const IAddBulletList = ({ bullets, text, description, anchorScroll }: IAddBulletListProps) => {
  const getTextPurified = (text: string) => purify([text || ''])?.[0] || '';

  return (
    <div id={anchorScroll ? 'anchorScroll' : ''}>
      {text && <CustomTitle dangerouslySetInnerHTML={{ __html: getTextPurified(text) }} />}
      {description && (
        <CustomDesc dangerouslySetInnerHTML={{ __html: getTextPurified(description) || '' }} />
      )}
      <BulletListContainer>
        <ListItemsWithImage
          textColor="#262626"
          elements={
            bullets?.map((e) => ({
              text: e?.text || '',
              icon: e?.image || '',
              subtext: e?.title || '',
            })) || []
          }
        />
      </BulletListContainer>
    </div>
  );
};

export default IAddBulletList;

